// ============================================================================
//  CHATBASE AI-AGENTER  —  central konfiguration
// ----------------------------------------------------------------------------
//  Alle live demo-agenter + hjemmeside-agenten drives af Chatbase.
//  For at gøre en agent LIVE: opret agenten i Chatbase, kopiér dens
//  "Chatbot ID" (Settings → General / Connect → Embed) og indsæt den nedenfor.
//  Tom streng ('') = ikke klar endnu (viser en pæn "under opsætning"-tilstand).
// ============================================================================

const chatbaseAgents = {
  'restaurant-agent': {
    chatbotId: '', // ← indsæt Chatbase chatbot-ID her
    businessName: 'Restaurant Fjord',
    accent: '#c9a227',
    industry: 'Restaurant',
    heroTitle: 'Mød restaurantens AI-vært',
    heroSub:
      'Booker borde, svarer på menu og allergener og tager imod takeaway – 24/7, direkte i chatten.',
    samples: [
      'Kan jeg booke bord til 4 på fredag?',
      'Hvad er på menuen?',
      'Har I glutenfri retter?',
      'Har I takeaway?'
    ],
    facts: [
      { k: 'Svarer', v: '24/7 på dansk' },
      { k: 'Kan', v: 'Booke borde i chatten' },
      { k: 'Trænet på', v: 'Menu & allergener' }
    ]
  }
};

// Chatbot-ID til Nordic Digitals egen hjemmeside-agent (vises på hele sitet).
export const SITE_CHATBOT_ID = '6hYRBm8qj4XWRH-GfFVS0';

export const isAgentLive = (agent) => Boolean(agent && agent.chatbotId);

export default chatbaseAgents;
